/**
 * MSI3 app registry — live apps and hidden stubs for future teaching apps.
 * Stubs never appear in any launcher and have no routes or marketing.
 */

/** @typedef {"live" | "stub"} Msi3AppStatus */

/**
 * @typedef {object} Msi3AppEntry
 * @property {string} id
 * @property {string} displayName
 * @property {Msi3AppStatus} status
 * @property {string | null} route
 * @property {string} adapterId
 */

/** @type {readonly Msi3AppEntry[]} */
export const MSI3_APP_REGISTRY = Object.freeze([
  Object.freeze({
    id: "clinicalHud5",
    displayName: "MorningReport Cases",
    status: "live",
    route: "/clinical-hud-5",
    adapterId: "clinicalHud5",
  }),
  Object.freeze({
    id: "morningreport-faculty",
    displayName: "MorningReport Faculty",
    status: "live",
    route: "/msi3/faculty/cases",
    adapterId: "morningreport-faculty",
  }),
  Object.freeze({
    id: "msi3StubApp1",
    displayName: "MSI3 Stub App 1",
    status: "stub",
    route: null,
    adapterId: "msi3StubApp1",
  }),
  Object.freeze({
    id: "msi3StubApp2",
    displayName: "MSI3 Stub App 2",
    status: "stub",
    route: null,
    adapterId: "msi3StubApp2",
  }),
]);

/**
 * Apps that may appear in a launcher (live only). Stubs are always hidden.
 * @returns {Msi3AppEntry[]}
 */
export function getLiveMsi3Apps() {
  return MSI3_APP_REGISTRY.filter((app) => app.status === "live");
}

/**
 * @param {string} id
 * @returns {Msi3AppEntry | undefined}
 */
export function getMsi3AppById(id) {
  return MSI3_APP_REGISTRY.find((app) => app.id === id);
}
